module.exports = "<p>ברשימת התמונות שתמצאו מימין למפה, תוכלו לסמן בלב דירה שתרצו לחזור אליה בעתיד. אחר כך תוכלו למצוא את כל הדירות שאהבתם ברשימה מסודרת, על ידי לחיצה על הלב שמופיע מעל רשימת הדירות שהעלה חיפושכם. אם אתם מחוברים לאתר, הרשימה של הדירות שאהבתם תישמר ותחכה לכם גם בפעם הבאה שתתחברו לאתר. אם אתם לא במצב רוח של לבבות, אפשר גם ללחוץ על מודעה של דירה וכשהיא תפתח, ללחוץ על הלחצן של החץ שבראש המודעה. המודעה תיפתח בטאב נוסף בגלשן שלכם, ואתם תוכלו לחזור לשוטט במפה בלב שקט.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/12.md
// module id = 794
// module chunks = 0